import websitePublisher from './website-publisher';

export default {
  websitePublisher,
};
